import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    $(this.element).datepicker({
      prevText: "",
      nextText: "",
      onSelect: function(string, obj) {
        obj.input[0].dispatchEvent(new Event("change"));
      },
      beforeShow: function(input, inst) {
        $("#ui-datepicker-div").removeClass(function() {
          return "ui-datepicker--modern-theme";
        });

        $("#ui-datepicker-div").addClass("ui-datepicker--modern-theme");
      }
    });
    $(this.element).mask("00/00/0000");
    $(this.element).on("change", this.handleInvalid);
    $(this.element).on("input", this.handleInvalid);
  }

  disconnect() {
    $(this.element).off("change", this.handleInvalid);
    $(this.element).off("input", this.handleInvalid);
  }

  handleInvalid(event){
    event.currentTarget.setCustomValidity("")
    const date = event.currentTarget.value
    if (!date || date.length == 0) return
    if (date.length == 10 && moment(date, "DD/MM/YYYY").isValid()) return

    event.currentTarget.setCustomValidity("Data não é válida")
  }
}
